/**
 * @author caijianjia
 * @date 2020/4/26 4:31 下午
 */
export const tableHead = [
  {
    prop: 'name',
    label: '课件名称',
  },
  {
    prop: 'title',
    label: '课件标题',
  },
  {
    prop: 'category_name',
    label: '所属分类',
  },
  {
    prop: 'type',
    label: '课件类型',
  },
  {
    prop: 'created_at',
    label: '创建时间',
  },
  {
    prop: 'updated_at',
    label: '更新时间',
  },
  {
    prop: 'package_status',
    label: '发布状态',
  },
  {
    prop: 'school_name',
    label: '校区名称',
  },
  {
    prop: 'create_name',
    label: '创建人',
  },
  {
    prop: 'mobile',
    label: '手机号',
  },
  {
    prop: 'update_name',
    label: '最后修改',
  },
  /*{
    prop: 'operate',
    label: '查看详情',
    width: 105
  },*/
];

export const tableData = [];



// WEBPACK FOOTER //
// ./src/views/CampusManagement/campusYunPt/fields.js